import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {
  Inject,
  Injectable,
  Optional,
  PLATFORM_ID,
  inject,
  makeStateKey,
  signal,
} from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { NotificationService } from '../../shared/components/notification/notification.service';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { EXPRESS_HOST, SERVER_COOKIES } from '../../app.module';
import { TransferState } from '@angular/platform-browser';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoadingService } from '@shared/services/loading.service';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express'; 

@Injectable()
export class GlobalHttpErrorHandler implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private loadingService: LoadingService,
    @Inject(DOCUMENT) private document: Document,
    @Optional() @Inject(SERVER_COOKIES) private rawHeaders: string[],
    @Optional() @Inject(EXPRESS_HOST) baseUrl?: string,
    @Optional() @Inject(RESPONSE) private response?: Response // حالا از express است
  ) {
    if (isPlatformServer(this.platformId)) {
      this.transferState.set(this.expressUrl, baseUrl);
    } else baseUrl = this.transferState.get(this.expressUrl, '');

    this.baseUrl = baseUrl ?? '';
  }

  router = inject(Router);
  route = inject(ActivatedRoute);
  private notif = inject(NotificationService);
  transferState: TransferState = inject(TransferState);
  headers = makeStateKey<string[]>('headers');
  expressUrl = makeStateKey<string>('expressUrl');
  interceptedFirstRequest = signal(false);
  routeValidation = makeStateKey<boolean>('routeValidation');
  baseUrl: string;

  createCookies(cookieIndex: any, refererIndex: any): any {
    const headers: any = {};
    headers['x-service-agent'] = 'website';
    if (this.rawHeaders) {
      this.rawHeaders?.[cookieIndex + 1]?.split(';').forEach((header, index) => {
        headers[header?.split('=')[0].trimStart()] = header?.split('=')[1];
      });
    }
    return headers;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (isPlatformServer(this.platformId)) {
      let newHeaders: any;
      let newCookies: any;
      let newReferer: any;

      if (this.rawHeaders?.length) {
        // Raw document headers may contain HttpOnly cookies or Authorization. Keep them
        // server-only; TransferState is embedded in the response HTML.
        const cookieIndex =
          this.rawHeaders?.indexOf('Cookie') == -1
            ? this.rawHeaders?.indexOf('cookie')
            : this.rawHeaders?.indexOf('Cookie');
        const refererIndex =
          this.rawHeaders?.indexOf('Referer') == -1
            ? this.rawHeaders?.indexOf('referer')
            : this.rawHeaders?.indexOf('Referer');

        newCookies = this.rawHeaders[cookieIndex + 1];
        newReferer = this.rawHeaders[refererIndex + 1]?.includes('http')
          ? this.rawHeaders?.[refererIndex + 1]
          : '';

        newHeaders = new HttpHeaders({
          Cookie: this.rawHeaders[cookieIndex + 1],
          Referer: this.rawHeaders[refererIndex + 1]?.includes('http')
            ? this.rawHeaders?.[refererIndex + 1]
            : '',
        });

        newHeaders.set('Cookie', this.rawHeaders[cookieIndex + 1]);
        newHeaders.set(
          'Referer',
          this.rawHeaders?.[refererIndex + 1]?.includes('http')
            ? this.rawHeaders?.[refererIndex + 1]
            : ''
        );
      }

      const newRequest = request.clone({
        headers: request.headers,
    
      });

      return next.handle(newRequest).pipe(
        tap((response) => {
          //  چک کردن status code در SSR
          if ((response as any)?.status && this.response && (response as any).status !== 200) {
            try {
              this.response.status((response as any).status);
            } catch (e) {
              // ignore if headers already sent
            }
          }
        }),

         
      
        catchError((err) => {
          if (err.status === 0) {
            // CORS Error
          }
          if (err.status === 500) {
            let a = this.document.createElement('div');
            a.innerHTML = 'unfortunately server error occurred 500';
            a.className = 'hidden-custom server-error';
            this.document.body.appendChild(a);
           
          }
          if (err.status === 404) {
            let a = this.document.createElement('div');
            a.innerHTML = 'unfortunately no content is found 404';
            a.className = 'hidden-custom not-found';
            this.document.body.appendChild(a);
          }
          if (err.status === 400) {
            let a = this.document.createElement('div');
            a.innerHTML = 'unfortunately no content is found 400';
            a.className = 'hidden-custom not-found';
            this.document.body.appendChild(a);
            this.router.navigate(['notfound']);
          }

          //  ست کردن status code در SSR برای خطاها
          if (this.response) {
            try {
              this.response.status(err.status || 500);
            } catch (e) {
              // ignore if headers already sent
            }
          }

          throw err;
        })
      );
    } else {
      // Browser side
      return next.handle(request).pipe(
        takeUntilDestroyed(),
        tap((response) => {
          if (
            this.transferState.get(this.routeValidation, false) &&
            !this.router.routerState.snapshot.url.toLocaleLowerCase().includes('ecolodge')
          ) {
            this.router.navigate(['notfound']);
          }
        }),

        catchError((err) => {

          if (err.status === 500) {
            console.error('500 - Internal Server Error');
            let mainElement = this.document.querySelector('main');
            if (mainElement) {
              mainElement.innerHTML = `
          <div class="container">
            <div class="w-full flex justify-center my-10 flex-col text-center items-center">
              <img src="https://www.iranhotelonline.com/content/assets/images/error500.svg" 
                   alt="500 server error"
                   class="lg:w-[748px] w-full lg:h-[333px] object-contain"
                   onerror="this.style.display='none'">
              <h3 class="mt-5">متأسفانه خطایی در سرور رخ داده است :(</h3>
              <p class="text-gray-600 mt-2">لطفاً چند لحظه دیگر دوباره تلاش کنید</p>
              <a href="/" class="text-blue-500 mt-3">
                بازگشت به صفحه اصلی
              </a>
            </div>
          </div>
        `;
            }
          }
          if (err.status === 404) {
            console.error('404 - Page Not Found');
            let mainElement = this.document.querySelector('main');
            if (mainElement) {
              mainElement.innerHTML = `
                <div class="container">
                  <div class="w-full flex justify-center my-10 flex-col text-center items-center">
                    <img src="https://www.iranhotelonline.com/content/assets/images/error404.svg" alt="404 page error"
                      class="lg:w-[748px] w-full lg:h-[333px] object-contain">
                    <h3 class="mt-5">صفحه مورد نظر یافت نشد:(</h3>
                    <a href="/" class="text-blue-500 mt-3">
                      بازگشت به صفحه اصلی
                    </a>
                  </div>
                </div>
              `;
            }
          }
          if (err.status === 400 && (err.url.includes('getHotelSummaryInfo') ||
            err.url.includes('search/filter') ||
            err.url.includes('GetAllSections'))
          ) {
            console.error('400 - Bad Request');
            let errText = `متاسفانه در ارتباط با سرور اختلالی پیش اومده.<br /> 
              <a href="/" class="text-blue-500">
                بازگشت به صفحه اصلی
              </a>`;
            this.loadingService.showNavigation(errText);
          }

          throw err;
        })
      );
    }
  }
}
